import { Drawer as MuiDrawer } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Drawer = styled(MuiDrawer)`
  .MuiPaper-root {
    background: ${theme.colors.surfaceContainerBackground};
    min-width: 351px;
    width: 512px;
    border-left: 1px solid ${theme.colors.strokePrimary};

    ::-webkit-scrollbar {
      display: none;
    }

    .wrapper-inner {
      width: 100%;

      .header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: ${theme.spacing.medium}px;
        border-bottom: 1px solid ${theme.colors.strokePrimary};

        .title {
          font-family: ${theme.typography.fontFamily.primary};
          font-size: ${theme.typography.fontSize.xxxLarge};
          font-style: normal;
          font-weight: ${theme.typography.fontWeight.bold};
          line-height: normal;
          color: ${theme.colors.foreground};
        }
      }

      .content {
        padding: ${theme.spacing.medium}px;
        overflow-y: scroll;
        height: calc(100vh - 89px);

        &::-webkit-scrollbar {
          width: 4px;
          background: transparent;
        }

        &::-webkit-scrollbar-track {
          box-shadow: none;
          background: ${theme.colors.strokePrimary};
        }

        &::-webkit-scrollbar-thumb {
          background-color: ${theme.colors.cta};
          border-radius: ${theme.attributes.borderRadius.quaternary};
        }

        .row-item {
          border-bottom: 1px solid ${theme.colors.strokePrimary};
          padding-bottom: 24px;
          margin-bottom: 32px;

          .row-name {
            color: ${theme.colors.foreground};
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.xLarge};
            font-style: normal;
            font-weight: ${theme.typography.fontWeight.thin};
            line-height: normal;
            margin-bottom: ${theme.spacing.small}px;
          }

          .row-data {
            display: flex;
            flex-direction: column;
            gap: ${theme.spacing.small}px;

            .data-item {
              display: flex;
              align-items: center;
              gap: ${theme.spacing.xSmall}px;

              img {
                min-width: 24px !important;
                min-height: 24px !important;
              }

              .name {
                color: ${theme.colors.foreground};
                font-family: ${theme.typography.fontFamily.primary};
                font-size: ${theme.typography.fontSize.xLarge};
                font-style: normal;
                font-weight: ${theme.typography.fontWeight.normal};
                line-height: normal;
                white-space: pre-line;
                word-break: break-all;

                &.empty-cell {
                  color: ${theme.colors.devicesEmptyCell};
                }
              }
            }
          }
        }
      }
    }
  }
`
